import React, { useState, useEffect } from 'react';
import { supabase } from '../api/supabase';
import { Box, Typography, Button, TextField, Dialog, DialogActions, DialogContent, DialogTitle, List, ListItem, ListItemText, IconButton, Paper, Alert } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import Loader from '../components/common/Loader';

const ExpensesPage = () => {
  const [expenses, setExpenses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [open, setOpen] = useState(false);
  const [currentExpense, setCurrentExpense] = useState({ description: '', amount: '', expense_date: new Date().toISOString().slice(0, 10) });
  const [error, setError] = useState('');

  useEffect(() => { fetchExpenses(); }, []);

  const fetchExpenses = async () => {
    setLoading(true);
    const { data, error } = await supabase.from('expenses').select('*').order('expense_date', { ascending: false });
    if (error) setError('Falha ao buscar gastos.');
    else setExpenses(data);
    setLoading(false);
  };

  const handleOpen = () => {
    setCurrentExpense({ description: '', amount: '', expense_date: new Date().toISOString().slice(0, 10) });
    setOpen(true);
  };

  const handleClose = () => { setOpen(false); setError(''); };
  
  const handleDelete = async (id) => {
    const { error } = await supabase.from('expenses').delete().eq('id', id);
    if (error) alert('Falha ao deletar gasto.');
    else fetchExpenses();
  };

  const handleSave = async () => {
    if (!currentExpense.description || !currentExpense.amount || !currentExpense.expense_date) {
      setError('Todos os campos são obrigatórios.');
      return;
    }
    const { error } = await supabase.from('expenses').insert([{...currentExpense, amount: parseFloat(currentExpense.amount)}]);

    if (error) setError(`Falha ao salvar gasto.`);
    else { handleClose(); fetchExpenses(); }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setCurrentExpense(prev => ({ ...prev, [name]: value }));
  };

  const totalExpenses = expenses.reduce((acc, exp) => acc + Number(exp.amount), 0);

  return (
    <Box>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
        <Typography variant="h5">Gastos e Investimentos</Typography>
        <Button variant="contained" startIcon={<AddIcon />} onClick={handleOpen}>Novo Gasto</Button>
      </Box>
      
      <Typography variant="h6" gutterBottom>Total de Gastos: {totalExpenses.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</Typography>

      {loading ? <Loader /> : (
        <Paper>
          <List>
            {expenses.map(exp => (
              <ListItem key={exp.id} secondaryAction={<IconButton edge="end" onClick={() => handleDelete(exp.id)}><DeleteIcon /></IconButton>}>
                <ListItemText
                  primary={exp.description}
                  secondary={`${new Date(exp.expense_date).toLocaleDateString("pt-BR", {timeZone: 'UTC'})} - ${Number(exp.amount).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}`}
                />
              </ListItem>
            ))}
          </List>
        </Paper>
      )}

      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>Novo Gasto</DialogTitle>
        <DialogContent>
          {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
          <TextField autoFocus margin="dense" name="description" label="Descrição do Gasto" type="text" fullWidth value={currentExpense.description} onChange={handleChange} />
          <TextField margin="dense" name="amount" label="Valor (R$)" type="number" fullWidth value={currentExpense.amount} onChange={handleChange} />
          <TextField margin="dense" name="expense_date" label="Data do Gasto" type="date" fullWidth value={currentExpense.expense_date} onChange={handleChange} InputLabelProps={{ shrink: true }}/>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancelar</Button>
          <Button onClick={handleSave}>Adicionar</Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default ExpensesPage;